module.exports = __webpack_public_path__ + "src/assets/img/changedisc.78c50597.png";